<template>
	<v-container>
		<v-card id="action-plan"> 
			<v-col>
				<h1>Action Plan : <span style="font-size: 0.8em;">{{ this.$store.getters.selectedTitle }}</span></h1>
			</v-col>
			<v-col>
				<p style="font-size: 16px; margin-left: 10px; margin-right: 10px; text-align: justify;">Using this table, you can create action plans to address and mitigate each risk. You can assign mitigation measures, monitor their status, and designate responsible parties for each action. Additionally, you can update or delete mitigation plans as necessary to ensure effective risk management. </p>
			</v-col>
			<v-col class="addnewbutton">
				<v-btn
					color="primary"
					:to="{
						path: '/csr/riskmatrix/addaction',
						query: { matrixID: selectedId },
					}"
					:disabled="isButtonDisabled"
				>
					<v-icon left>fas fa-plus</v-icon>NEW
				</v-btn>
			</v-col>
			<v-card-title>
				<v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
					hide-details></v-text-field>
			</v-card-title>
			<v-data-table
				theme--light
				:headers="headers"
				:items="connections"
				:search="search"
				:items-per-page="20"
				class="light table"
				:footer-props="{
					'items-per-page-options': [5, 10, 15, 20],
				}"
			>
				<template v-slot:header="{ headers }">
					<thead>
						<tr>
							<th
								v-for="header in headers"
								:key="header.text"
								class="custom-header"
							>
								{{ header.text }}
							</th>
						</tr>
					</thead>
				</template>
				<template v-slot:item.Description="{ item }">
					<td style="text-align: justify;">
						<span>{{ item.Description }}</span>
					</td>
				</template>
				<template v-slot:item.Connection_to_risk="{ item }">
					<td style="text-align: center;">
						<span>{{ item.Connection_to_risk }}</span>
					</td>
				</template>
				<template v-slot:item.Assigned="{ item }">
					<td style="text-align: center;">
						<span>{{ item.Assigned }}</span>
					</td>
				</template>
				<template v-slot:item.Created="{ item }">
					<td style="text-align: center;">
						<span>{{ item.Created }}</span>
					</td>
				</template>
				<template v-slot:item.ExpiryDate="{ item }">
					<td style="text-align: center;">
						<span>{{ item.ExpiryDate }}</span>
					</td>
				</template>
				<template v-slot:item.editbutton="{ item }">
					<td class="small_cell" style="width: 30px; padding-right: 0px">
						<v-menu offset-y>
							<template v-slot:activator="{ on, attrs }">
								<div class="buttonfeather">
									<v-btn v-bind="attrs" v-on="on" small elevation="0" text>
										<v-icon>fas fa-ellipsis-v</v-icon>
									</v-btn>
								</div>
							</template>
							<v-list>
								<v-list-item @click="updateItem(item)" :disabled="!isActionAllowed">
									<v-list-item-title>Update</v-list-item-title>
								</v-list-item>
								<v-list-item @click="deleteItem(item)">
									<v-list-item-title>Delete</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</td>
				</template>
				<template v-slot:item.Status="{ item }">
					<td :class="getStatusClass(item.Status)">
						<span style="padding-left: 15px;">{{ getStatusText(item.Status) }}</span>
					</td>
				</template>
			</v-data-table>
			<v-dialog v-model="dialogDelete" max-width="500px">
				<v-card>
					<v-card-title
						>Are you sure you want to remove this Action?</v-card-title
					>
					<v-card-text
						>Once it is removed, you will not able to find it in the
						system</v-card-text
					>
					<v-card-actions>
						<v-btn color="primary" text @click="dialogDelete = false"
							>Close</v-btn
						>
						<v-btn color="error" text @click="removeRow">Delete</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-card>
	</v-container>
</template>

<script>
import { actionplanAPI } from "../api/csr/actionplan"
import LoadingState from "../consts/LoadingState"
import { mapGetters } from "vuex"

export default {
	data() {
		return {
			dialogDelete: false,
			connections: [],
			avgScore: [],
			dropdownItems: [
				{ title: "Total score", action: this.sortByTotalScore },
				{ title: "Human rights", action: this.sortByHumanRights },
				{ title: "Labour", action: this.sortByLabour },
				{ title: "Environment", action: this.sortByEnvironment },
				{ title: "Anticorruption", action: this.sortByAnticorruption },
				{ title: "Transparency Law", action: this.sortByTransparencyLaw },
			],
			search: "",
			headers: [
				{
					text: "Mitigation",
					align: "center",
					value: "Mitigation",
					sortable: false,
					width:"12%",
				},
				{
					text: "Description",
					align: "center",
					value: "Description",
					sortable: false,
					width:"40%",
				},
				{
					text: "Risk Connection",
					align: "center",
					value: "Connection_to_risk",
					sortable: false,
				},
				{
					text: "Status",
					value: "Status",
					sortable: false,
				},
				{
					text: "Assigned",
					value: "Assigned",
					align: "center",
					sortable: false,
				},
				{
					text: "Created",
					align: "center",
					value: "Created",
					sortable: false,
					width:"15%",
				},
				{
					text: "Expired date",
					align: "center",
					value: "ExpiryDate",
					sortable: false,
					width:"15%",
				},
				{
					value: "editbutton",
					sortable: false,
				},
			],
		}
	},
	computed: {
		...mapGetters([
			"selectedId",
			"selectedYear",
			"selectedTitle",
			"selectedDescription",
			"selectedStatus",
		]),
		isActionAllowed() {
			return this.selectedStatus === "Active"
		},
		isButtonDisabled() {
			return !this.isActionAllowed || this.selectedId === null
		},
	},
	watch: {
		selectedId(newVal) {
			console.log("Selected ID changed Risk Description:", newVal)
			this.loadActionItems(newVal)
		},
	},
	mounted() {
		this.loadActionItems(this.selectedId)
	},
	methods: {
		loadActionItems(id) {
			this.connections = []
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			actionplanAPI
				.getAll(id)
				.then((data) => {
					let editbutton = ""
					for (let entry of data[0]) {
						this.connections.push({
							ID: entry.id,
							Mitigation: entry.Mitigation,
							Description: entry.Description,
							Connection_to_risk: entry.Connected_to_risk,
							Status: entry.Status,
							Assigned: entry.Assigned,
							Created: entry.Created.split("T")[0],
							ExpiryDate: entry.ExpiryDate.split("T")[0],
							editbutton: editbutton,
						})
					}
					// Can't make a check inside for loop (eslint), have to remove it outside. Not a good fix.
					/*this.connections = this.connections.filter(function( obj ) {
						return obj.clientID !== 1 // clientID 1 is the user (client accessing the portal).
					})*/
					// Used by old method of showing sustainability
					//this.averageScore() // Calculating average score of all suppliers
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		deleteItem(item) {
			this.itemToDelete = item
			this.dialogDelete = !this.dialogDelete
		},
		updateItem(item) {
			this.$router.push({
				path: "/csr/riskmatrix/updateaction",
				query: {
					itemId: item.ID,
				},
			})
		},
		removeRow() {
			this.dialogDelete = false
			let index = this.connections.indexOf(this.itemToDelete)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			actionplanAPI
				.deleteAction(this.itemToDelete.ID)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Action Plan item was successfully removed from the list.",
						{ root: true }
					)
					this.connections.splice(index, 1)
					window.location.href = "/csr/riskmatrix/riskpage"
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getStatusText(status) {
			if (status == 1) {
				return "Done"
			} else if (status == 2) {
				return "Started"
			} else if (status == 3) {
				return "Planned"
			} else {
				return ""
			}
		},
		getStatusClass(status) {
			if (status == 1) {
				return "success--text"
			} else if (status == 2) {
				return "warning--text"
			} else if (status == 3) {
				return "red--text"
			} else {
				return ""
			}
		},
	},
}
</script>

<style>
.v-progress-circular {
	margin: 0rem;
}

.addnewbutton {
	display: flex;
	justify-content: flex-end;
}
.custom-header {
	font-size: 100px;
}
.v-data-table .v-data-table-header tr th {
	font-size: 15px !important;
	color: #217b7f !important;
}
</style>
